var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GroupsComponent DataTables"},[_vm._v("\n\n\n    "+_vm._s(_vm.lang.infotext_1)+"\n    "),_c('br'),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":_vm.id}}),_vm._v(" "),_c('ContextMenuComponent',{attrs:{"menu":_vm.menu,"id":_vm.name}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cb68ca6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/GroupsComponent.vue
// module id = null
// module chunks = 